import React, { useState, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

export default function FeaturedCarousel({ items = [] }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % items.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [items.length]);

  if (!items.length) return null;

  const next = () => setIndex((i) => (i + 1) % items.length);
  const prev = () => setIndex((i) => (i - 1 + items.length) % items.length);

  const current = items[index];

  return (
    <div className="relative w-full h-[330px] sm:h-[420px] md:h-[480px] rounded-xl overflow-hidden shadow-xxl">
      {/* Background image */}
      <Link to={`/actualites/${current.slug}`}>
        <div
          className="absolute inset-0 bg-center bg-cover"
          style={{ backgroundImage: `url(${current.image})` }}
        />

        {/* Bottom gradient */}
        <div
          className="
        absolute inset-0 
        bg-gradient-to-t 
        from-black/70 via-black/30 to-transparent
      "
        />

        {/* Title + Link */}
        <div className="absolute bottom-8 left-6 text-white px-2 space-y-2">
          <h2 className="text-2xl sm:text-3xl font-bold drop-shadow-xl">
            {current.title}
          </h2>

          {/* ---- Lire l'article ---- */}
          <Link
            to={`/actualites/${current.slug}`}
            className="
            inline-flex items-center gap-2 
            text-white font-semibold 
            hover:underline 
          "
          >
            Lire l’article
            <ChevronRightIcon className="w-4 h-4" />
          </Link>
        </div>
      </Link>

      {/* Navigation arrows */}
      <button
        onClick={prev}
        className="
          absolute left-4 top-1/2 -translate-y-1/2 
          bg-white/70 hover:bg-white 
          p-2 rounded-full shadow-md transition
        "
      >
        <ChevronLeftIcon className="h-6 w-6 text-[#3a3a3a]" />
      </button>

      <button
        onClick={next}
        className="
          absolute right-4 top-1/2 -translate-y-1/2 
          bg-white/70 hover:bg-white 
          p-2 rounded-full shadow-md transition
        "
      >
        <ChevronRightIcon className="h-6 w-6 text-[#3a3a3a]" />
      </button>
    </div>
  );
}
